import React, { PureComponent } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

class Denied extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
    };
    useBasicAuth.checkToken();
  }

  render() {
    const { t } = this.props;

    return (
      <Container className="dashboard">
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.denied_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.denied_form.description')}</h3>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Link to="/home" className="btn btn-primary">
              {t('sidebarContent.cruds.home')}
            </Link>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withTranslation('common')(Denied);
